import React, { useState, Fragment } from "react";
import {
    TextField,
    Box,
    CircularProgress,
    Autocomplete,
    Grid,
    Alert,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import SearchIcon from "@mui/icons-material/Search";
import useManufacturers from "../hooks/getManufacters";
import axios from "axios";
import Datatable from "../components/PcnsDataTable";

function SearchPCN() {
    const [buttonLoading, setButtonLoading] = useState(false);
    const [manufacturer, setManufacturer] = useState("");
    const [pcn, setPcn] = useState("");
    const [parts, setParts] = useState([]);
    const [loadingParts, setLoadingParts] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const [showAlert, setShowAlert] = useState(false);

    const handleSearch = async () => {
        setLoadingParts(true);
        setButtonLoading(true);
        setShowTable(false);

        const mfr =
            manufacturer !== null && typeof manufacturer.id !== "undefined"
                ? `&mfr=${manufacturer.id}`
                : "";

        var search_url = `${process.env.REACT_APP_APIM_URL}/pcn-search?keyword=${pcn.toUpperCase()}${mfr}&start=0&limit=2000`;
        search_url += "&bc=" + process.env.REACT_APP_SBOAT;

        const requestOptions = {
            headers: { "Ocp-Apim-Subscription-Key": process.env.REACT_APP_APIM_KEY },
        };

        await axios
            .get(search_url, requestOptions)
            .then((resp) => {
                let data = resp.data.data.rows;
                data.length === 0 ? setShowAlert(true) : setShowAlert(false);
                setParts(data);
                setShowTable(true);
                setLoadingParts(false);
                setButtonLoading(false);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const { data, isLoading } = useManufacturers();

    return (
        <Fragment>
            <Grid
                container
                columnSpacing={2}
                alignItems="center"
                justifyContent="flex-start"
                sx={{
                    p: 4,
                    border: "1px solid #ccc",
                    background: "#fafafa",
                    borderRadius: 0,
                    mt: 5,
                    flexDirection: "row",
                    display: "flex",
                    marginLeft: "0 !important",
                    width: "100% !important",
                }}
            >
                <Grid item xs={12} sm={4}>
                    {isLoading ? (
                        <CircularProgress color="primary" />
                    ) : (
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={data}
                            sx={{ mr: 5 }}
                            size="small"
                            renderInput={(params) => (
                                <TextField {...params} label="Manufacturer" />
                            )}
                            fullWidth
                            onChange={(e, newValue) =>
                                setManufacturer(newValue)
                            }
                        />
                    )}
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextField
                        required
                        id="outlined-basic"
                        label="PCN Id, PCN Mfr Id, Subject or Material"
                        title="Search by PCN Id, PCN Mfr Id, Subject or Material"
                        variant="outlined"
                        value={pcn}
                        onChange={(e) => setPcn(e.target.value)}
                        size="small"
                        fullWidth
                        onKeyPress={(event) => {
                            if (event.charCode === 13) {
                                handleSearch();
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={2}>
                    <LoadingButton
                        onClick={handleSearch}
                        loading={buttonLoading}
                        startIcon={<SearchIcon />}
                        loadingIndicator="Searching..."
                        variant="contained"
                        disabled={pcn.length < 3 ? true : false}
                        size="large"
                        color="warning"
                        sx={{ width: "100%" }}
                    >
                        Search
                    </LoadingButton>
                </Grid>
            </Grid>

            {loadingParts && !showTable ? (
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="top"
                    minHeight="80vh"
                    sx={{ mt: 5, p: 0 }}
                >
                    <CircularProgress color="primary" />
                </Box>
            ) : (
                <Box
                    container
                    columnSpacing={2}
                    alignItems="center"
                    sx={{ mt: 5 }}
                >
                    {showTable && parts.length > 0 && (
                        <Datatable pcns={parts} />
                    )}
                </Box>
            )}

            <Box container columnSpacing={2} alignItems="center" sx={{ mt: 5 }}>
                {showAlert && (
                    <Alert severity="warning">
                        No results found for given search criteria.
                    </Alert>
                )}
            </Box>
        </Fragment>
    );
}

export default SearchPCN;
